import axios from 'axios'
import { RootPath } from './config'

const postServices = (endpoint, data) => {
    const promise = new Promise ((resolve, reject) => {
        axios.post(RootPath + endpoint, data)
            .then((res) => {
                resolve(res);
            }, (error) => {
                reject(error);
            })
    })
    return promise;
}

export default postServices;